<template>
  <Form :model="formItem" :label-width="80">
    <Row>
      <Col span="10">
    <!--   <FormItem label="查询内容">
        <Input v-model="formItem.inputfilename" class="common-width" placeholder="查询内容"></Input>
      </FormItem> -->
<!--       <FormItem label="文号">
        <Input v-model="formItem.inputnumber" class="common-width" placeholder="文号"></Input>
      </FormItem> -->
      </Col>
    </Row>
    <Row>
      <Col span="10">
      <FormItem label="行业">
        <!--     <Select v-model="formItem.industryselected" multiple class="common-width" placeholder="行业">
          <Option v-for="item in industry" :value="item.value" :key="item.value">{{ item.label }}</Option>
        </Select> -->
        <SingleSelect  class="common-width" ref="industrySelector" @onClearText="onIndustryClearText" @tag-Select="getIndustrySelection"></SingleSelect>
      </FormItem>
      <!-- 20190822 -->
      <!-- <FormItem label="">
        <SingleSelect class="common-width" ref="taxSelector" @onClearText="onTaxClearText" @tag-Select="getTaxSelection"></SingleSelect>
      </FormItem> -->
<!--       <FormItem label="">
        <Input v-model="formItem.inputothers" class="common-width" placeholder="其他"></Input>
      </FormItem> -->
      </Col>
    </Row>
    <!-- 注释于2019.08.19,注释原因：所有引擎取消时间查询条件,改为在二次检索结果中输入时间 -->
    <!-- <FormItem label="时间">
      <Row>
        <Col span="10">
        <DatePicker type="daterange" format="yyyy-MM-dd" placement="bottom-end" class="common-width" placeholder="成文/解读时间范围" v-model="formItem.da" @on-change="timeOnChange"></DatePicker>
        </Col>
      </Row>
    </FormItem> -->

    <FormItem label="文件效力">
      <SingleSelect class="common-width" :tData="sTreeData" @onClearText="onForceClearText" @tag-Select="getForceSelection"></SingleSelect>
      <!--     <ButtonGroup>
        <Button v-for="item in formItem.fileforce" :type="item.type" :key="item.key" @click="ButtonGroupSelect(item.id)">{{item.value}}</Button>
      </ButtonGroup> -->
    </FormItem>
    <!--     <FormItem label="适用范围">
      <RadioGroup v-model="formItem.radio">
        <Radio label="global">全国版</Radio>
        <Radio label="loacal">地方版</Radio>
      </RadioGroup>
    </FormItem> -->
    <FormItem>
      <Button type="primary" icon="ios-search" size="default" @click="Submit()">查询</Button>
      <!-- <Button type="dashed"><router-link to="/main/identical/myidentical">涉税同名文件查询系统</router-link></Button> -->
    </FormItem>
  </Form>
</template>
<script>
import SelectData from '../../../assets/json/selectData.json'
import TreeSingleselect from '../../common/tree-single-select.vue'
import { mapState, mapMutations, mapActions, mapGetters } from 'vuex'
import ConstJson from '../../../api/common/constjson.js'
import treeData2 from '../../../assets/json/select-tree2.json'
let constJ = new ConstJson()
export default {
  name: "SearchEngine",
  inject: ['expand'],
  data() {
    return {
      formItem: {
        inputfilename: '',
        inputnumber: '',
        inputothers: '',
        industryselected: {},
        taxcategoryselected: {},
        radio: 'global',
        // switch: true,
        da: [],
        fileforce: SelectData.fileforce
      },
      // industry: SelectData.industry,
      // cList: SelectData.taxcategory,
      industry: {},
      cList: {},
      model11: [],
      sTreeData: this.getSelectTreeData(),
    }
  },
  methods: {
    ButtonGroupSelect(id) {
      var item = this.formItem.fileforce[id];
      item.Selected = !item.Selected;
      if (item.Selected == true) {
        item.type = "primary";
      } else {
        item.type = "default";
      }
      //console.log(this.formItem.fileforce);
    },
    timeOnChange() {
      var time = []
      if (this.formItem.da[0] !== "") {
        time[0] = this.getFormattedDate(this.formItem.da[0])
        time[1] = this.getFormattedDate(this.formItem.da[1])
        this.formItem.da=time
      }else{

      }
    },
    getFormattedDate(date) {
      var year = date.getFullYear();
      var month = (1 + date.getMonth()).toString();
      month = month.length > 1 ? month : '0' + month;
      var day = date.getDate().toString();
      day = day.length > 1 ? day : '0' + day;
      return year + '-' + month + '-' + day;
    },
    Submit() {

      console.log(this.formItem)

      if (this.sliderLength >= 2) {
        this.screenSet(true);
      }
      this.$emit('onEngineSearch', this.formItem)

      //this.expand();

      //console.log(this.$store.state.count);
      //console.log(this.count)
      //console.log(this.ct)
      //console.log(this.$store.state.count)
      //console.log(this.$store.state.count);
      //this.$emit('onCommonSearch')
      // console.log("searchengine");
      // console.log(this.formItem);
    },
    //临时登录
    handle_tmpLogin() {
      //console.log(this.sta.isLogin)
      this.handleTempLogin()
        .then(res => {
          console.log("临时用户登录成功,需要初始化所有临时数据")
          //console.log(this.sta.initData.leftTree)
          //this.handle_lefttree()
          //console.log(this.sta.isLogin)
        })
        .catch(err => {
          console.log(err)
        })
    },
    load_selected() {
      //console.log("searchengine loading..." + this.sta.isLogin)
      if (this.sta.isLogin !== undefined && this.sta.isLogin) {
        this.industry = this.sta.initData.industry;
        this.cList = this.sta.initData.taxes;
      } else {
        this.handle_tmpLogin()
      }
    },
    propDataInit(data, placeholder, searchable) {
      var a = {}
      a.data = data
      a.placeholder = placeholder
      a.searchable = searchable
      return a
    },
    getIndustrySelection(node) {
      this.formItem.industryselected = node
      // console.log(this.formItem.industryselected)

    },
    getTaxSelection(node) {
      this.formItem.taxcategoryselected = node
      // console.log(this.formItem.taxcategoryselected.id)
    },
    getForceSelection(node){
      this.formItem.fileforce = node
    },
    onIndustryClearText(){
      //console.log("clear")
      this.formItem.industryselected={}
    },
    onTaxClearText(){
      this.formItem.taxcategoryselected={}
    },
    onForceClearText(){
      this.formItem.fileforce={}
    },
    ...mapMutations([
      'screenSet', 'setSliderLength'
    ]),
    ...mapActions([
      'handleTempLogin' //vuex中定义的actions
    ]),
    getSelectTreeData() {
      return treeData2.force
    },
    bindIndustry() {
      let obj = this.propDataInit(this.sta.initData.industry, "选择行业", false)
      this.industry = obj
      this.$refs.industrySelector.bindData(obj)
    },
    bindTax() {
      let obj = this.propDataInit(this.sta.initData.taxes, "税种", false)
      this.clist = obj
      this.$refs.taxSelector.bindData(obj)
    },
    resetTime(){
      this.formItem.da=[]
    }
  },
  computed: {
    ...mapGetters(['sliderLength', 'sliderScreen', 'sta', 'industryData', 'taxesData', 'isLogin'])
  },
  mounted() {
    this.bindIndustry()
    ////20190822
    //this.bindTax()
  },
  components: {
    'SingleSelect': TreeSingleselect,
  },
  watch: {
    isLogin: function() {
      // if (this.isLogin == true) {
      //   this.load_selected();
      // }
      // console.log("isLogin")
      // console.log(this.isLogin)
      //this.load_selected();

    },
    industryData: function() {
      this.bindIndustry()
    },
    ////20190822
    // taxesData: function() {
    //   this.bindTax()
    // },

  }

}

</script>
<style scoped>
body {
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
}

.common-width {
  width: 300px;
}

</style>
